module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"tagSEO":"SEO Tags"},"fr":{"tagSEO":"Balises SEO"},"it":{"tagSEO":"Tag SEO"},"es":{"tagSEO":"Etiquetas SEO"},"de":{"tagSEO":"SEO-Tags"},"nl":{"tagSEO":"SEO-tags"}}')
  delete Component.options._Ctor
}
